jQuery(function ($) {
    $('.wc-wishlist-add-to-cart-block > a').on('click', function(e){
        e.preventDefault();
        const body = $('body');
        const executeCode = true;
        let button = $(this);

        if ( executeCode ) {
            let nonce = wc_wishlist_add_to_cart.wc_wishlist_add_to_cart_nonce;
            let productId = button.parent().find('.wc-wishlist-add-to-cart-block__variation_id').data('variationId');
            let quantity = 1;

            if ( productId && quantity ) {
                const data = {
                    action: 'wc_wishlist_add_to_cart',
                    security: nonce,
                    product_id: productId,
                    quantity: quantity,
                    variation_text: wc_ajax_add_to_cart.var_text,
                    price_text: wc_ajax_add_to_cart.price,
                    title: wc_ajax_add_to_cart.added_text,
                    product_title: wc_ajax_add_to_cart.p_name,
                    qty_text: wc_ajax_add_to_cart.quantity,
                    continue_btn_text: wc_ajax_add_to_cart.continue_shopping,
                    to_cart_btn_text: wc_ajax_add_to_cart.to_cart,
                    to_cart_btn_link: wc_ajax_add_to_cart.cart,
                };

                body.append("<div id='add-to-cart-pup-up' class='loading'></div>");

                AddToCart(data, button);
            }
        }

        return false;
    });

    $('.wc-wishlist-add-to-cart-block button[type="submit"]').on('click', function(e){
        let button = $(this);
        const body = $('body');
        const executeCode = true;

        e.preventDefault();

        if ( executeCode ) {
            let nonce = wc_wishlist_add_to_cart.wc_wishlist_add_to_cart_nonce;
            let productId = button.parent().find('input[name="product_id"]').val();
            let quantity = 1;

            if ( productId && quantity ) {
                const data = {
                    action: 'wc_wishlist_add_to_cart',
                    security: nonce,
                    product_id: productId,
                    quantity: quantity,
                    variation_text: wc_ajax_add_to_cart.var_text,
                    price_text: wc_ajax_add_to_cart.price,
                    title: wc_ajax_add_to_cart.added_text,
                    product_title: wc_ajax_add_to_cart.p_name,
                    qty_text: wc_ajax_add_to_cart.quantity,
                    continue_btn_text: wc_ajax_add_to_cart.continue_shopping,
                    to_cart_btn_text: wc_ajax_add_to_cart.to_cart,
                    to_cart_btn_link: wc_ajax_add_to_cart.cart,
                };

                body.append("<div id='add-to-cart-pup-up' class='loading'></div>");

                AddToCart(data, button);
            }
        }

        return false;
    });


    /**
     * @dsc
     * @param data
     * @param button
     *
     * @returns {boolean}
     */
    function AddToCart(data, button) {
        let ajaxUrl = wc_wishlist_add_to_cart.ajax_url;

        $(document.body).trigger('adding_to_cart', [button, data]);

        setMiniCartLoadingState();

        $.ajax({
            type: 'post',
            url: ajaxUrl,
            data: data,
            beforeSend: function (response) {
                button.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                button.addClass('added').removeClass('loading');
                $('#add-to-cart-pup-up.loading').removeClass('loading');
                $( document.body ).trigger( 'wc_fragments_loaded' );
            },
            success: function (response) {
                if ( response.error && response.wc_wishlist_add_to_cart ) {
                    window.location = response.wc_wishlist_add_to_cart;
                } else {
                    $('#add-to-cart-pup-up').append(response);
                    //executeCode = false;

                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, button]);
                }
            },
            error: function (err) {
                alert('Atvainojamies, kaut kas nogāja greizi. :(');
            }
        });

        //Close pop-up
        $(document).on('click', function(event) {
            if ( !$(event.target).closest('#add-to-cart-pup-up .popup-wrapper').length ) {
                closeModal();
            }

            //@TODO need to off this event after modal closed;
        });

        $('body.woocommerce-wishlist').on('click', '#add-to-cart-pup-up .close, #add-to-cart-pup-up .popup-continue-shopping', function () {
            closeModal();
            //@TODO need to off this event after modal closed;
        });
    }


    /**
     * @description Close modal
     *
     */
    function closeModal() {
        $('#add-to-cart-pup-up').remove();
    }


    /**
     * @description Close modal
     *
     * param {boolean} loading
     */
    function setMiniCartLoadingState(loading = true) {
        const loadingClass = 'loading';
        const minicartLink = $('.mini-cart-link');

        if (loading) {
            minicartLink.addClass(loadingClass);
        } else {
            minicartLink.removeClass(loadingClass);
        }
    }
});